import { render } from "./ImageControls.vue?vue&type=template&id=5e274576"
import script from "./ImageControls.vue?vue&type=script&lang=js"
export * from "./ImageControls.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__